import { render, staticRenderFns } from "./StudipFileSize.vue?vue&type=template&id=43eb9cfc&"
import script from "./StudipFileSize.vue?vue&type=script&lang=js&"
export * from "./StudipFileSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v4.6-hsfl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43eb9cfc')) {
      api.createRecord('43eb9cfc', component.options)
    } else {
      api.reload('43eb9cfc', component.options)
    }
    module.hot.accept("./StudipFileSize.vue?vue&type=template&id=43eb9cfc&", function () {
      api.rerender('43eb9cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/StudipFileSize.vue"
export default component.exports